var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.18 0H5.81C2.17 0 0 2.17 0 5.81V14.18C0 17.82 2.17 19.99 5.81 19.99H14.18C17.82 19.99 19.99 17.82 19.99 14.18V5.81C19.99 2.17 17.82 0 14.18 0Z",
    fill: "#00D3C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65217 12.4957C4.29565 12.4957 4 12.2001 4 11.8436V8.11311C4 7.75659 4.29565 7.46094 4.65217 7.46094C5.0087 7.46094 5.30435 7.75659 5.30435 8.11311V11.8436C5.30435 12.2088 5.0087 12.4957 4.65217 12.4957Z",
    fill: "#00D3C7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25984 13.7474C6.90332 13.7474 6.60767 13.4518 6.60767 13.0953V6.88655C6.60767 6.53003 6.90332 6.23438 7.25984 6.23438C7.61636 6.23438 7.91201 6.53003 7.91201 6.88655V13.0953C7.91201 13.4605 7.61636 13.7474 7.25984 13.7474Z",
    fill: "#00D3C7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.86751 14.9922C9.51098 14.9922 9.21533 14.6965 9.21533 14.34V5.64436C9.21533 5.28784 9.51098 4.99219 9.86751 4.99219C10.224 4.99219 10.5197 5.28784 10.5197 5.64436V14.34C10.5197 14.6965 10.224 14.9922 9.86751 14.9922Z",
    fill: "#00D3C7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4791 13.7474C12.1226 13.7474 11.8269 13.4518 11.8269 13.0953V6.88655C11.8269 6.53003 12.1226 6.23438 12.4791 6.23438C12.8356 6.23438 13.1313 6.53003 13.1313 6.88655V13.0953C13.1313 13.4605 12.8356 13.7474 12.4791 13.7474Z",
    fill: "#00D3C7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0867 12.4957C14.7302 12.4957 14.4346 12.2001 14.4346 11.8436V8.11311C14.4346 7.75659 14.7302 7.46094 15.0867 7.46094C15.4433 7.46094 15.7389 7.75659 15.7389 8.11311V11.8436C15.7389 12.2088 15.4433 12.4957 15.0867 12.4957Z",
    fill: "#00D3C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon05);
export default __webpack_public_path__ + "static/media/chat-icon-05.896f7d441d33eb84caca1418ba58c9e0.svg";
export { ForwardRef as ReactComponent };